import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import SEO from "@/components/seo/SEO";
import api from "@/lib/api";
import { stripMarkdown } from "@/lib/markdown";

export default function BlogListPage() {
  const { t, i18n } = useTranslation();
  const [posts, setPosts] = useState(null);
  const [postType, setPostType] = useState("article");
  const lang = i18n.language?.slice(0, 2) || "fr";

  useEffect(() => {
    setPosts(null);
    api.get("/blog", { params: { post_type: postType, lang } }).then(({ data }) => setPosts(data));
  }, [postType, lang]);

  return (
    <div className="max-w-4xl mx-auto px-6 sm:px-8 py-10 sm:py-14" data-testid="blog-list-page">
      <SEO title={`${t("blog.title")} | JobVinum`} description="Conseils, guides et actualités pour le recrutement saisonnier vitivinicole en Europe : vendanges, taille, mise en bouteille, obligations légales et bonnes pratiques."
           image="/blog-og-image.png" path="/blog" />
      <h1 className="font-heading text-2xl sm:text-3xl font-bold mb-8">{t("blog.title")}</h1>

      <Tabs value={postType} onValueChange={setPostType} className="mb-8">
        <TabsList className="rounded-xl">
          <TabsTrigger value="article" data-testid="blog-tab-articles">{t("blog.articles")}</TabsTrigger>
          <TabsTrigger value="faq" data-testid="blog-tab-faq">{t("blog.faq")}</TabsTrigger>
        </TabsList>
      </Tabs>

      {!posts ? (
        <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-[#4ba3b7]" /></div>
      ) : posts.length === 0 ? (
        <p className="text-center py-16 text-[#2B2B2B]/50" data-testid="blog-empty-message">{t("search.noResults")}</p>
      ) : (
        <div className="space-y-4">
          {posts.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`}
                  className="block bg-white rounded-2xl border border-black/5 shadow-[0_4px_24px_rgba(0,0,0,0.03)] p-6 hover:shadow-[0_8px_32px_rgba(0,0,0,0.06)] transition-shadow"
                  data-testid={`blog-post-link-${p.slug}`}>
              <h2 className="font-heading font-bold text-lg mb-2">{p.title}</h2>
              <p className="text-sm text-[#2B2B2B]/60 line-clamp-2">{stripMarkdown(p.content)}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
